import { useState } from 'react';

import ProfileImageUpload from "../../components/profile-image-upload";
import dayjs from "dayjs";
import Auth, {COMPANY_MANAGER, COMPANY_OWNER} from '../../lib/users/auth';

import TabBar from '../../components/tab-bar';

import AccountDetails from './components/account-details';
import AccountCompany from './components/account-company';
import AccountSecurity from './components/account-security';

export default function AccountContent(props) {
    const [ tab, selectedTab ] = useState(0);

    const tabs = [
        'My Details',
        'My Company',
        'Security'
    ]


    return (
        <div className="account">
            <TabBar tabs={tabs} tab={tab} setTab={selectedTab} />

            <div className="account__inner">
                { tab === 0 && <AccountDetails { ...props } /> }
                { tab === 1 && <AccountCompany { ...props } /> }
                { tab === 2 && <AccountSecurity { ...props } /> }
            </div>

        </div>
    )
}
